import Vue from 'vue'
import VueRouter from 'vue-router'
import Recos from '../views/Recos.vue'
import Perfume from '../views/Perfume.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Recos',
    component: Recos
  },
  {
    path: '/perfume/:id',
    name: 'Perfume',
    component: Perfume
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,from,next)=>{
  var reload = false
  if(to.query.lang){
    localStorage.setItem('ap_lang',to.query.lang)
    console.debug('set Language')
    store.commit('setLanguage',to.query.lang)
    // reload = true
    // delete to.query.lang
  }
  if(to.query.host_id){
    localStorage.setItem('host_id',to.query.host_id)
    console.debug('set host id',to.query.host_id)
    // reload = true
    // delete to.query.host_id
  }
  if(reload)
    next(to)
  next()
  
})


export default router
